import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable({
    providedIn: "root"
})
export class PiActiveFilter {
    includes = [];
    excludes = [];
    list = [];
    currentDtm = null;

    public start(list) {
        this.includes = [];
        this.excludes = [];
        this.list = list;

        return this;
    }

    public input(dt: Date) {
        this.currentDtm = moment(dt).startOf('day');

        return this;
    }

    public filter() {
        this.excludes = this.list.filter(entry => {
            const activeDtm = this.toMoment(entry.Active);
            const deactiveDtm = this.toMoment(entry.Deactive);

            if (!activeDtm.isValid()) {
                return false;
            }

            if (deactiveDtm.isValid()) {
                return activeDtm >= this.currentDtm || deactiveDtm <= this.currentDtm;
            }
            else {
                return activeDtm >= this.currentDtm;
            }
        });

        return this;
    }

    public exclude() {
        return Array.from(this.excludes);
    }

    public include() {
        return Array.from(this.includes);
    }

    private toMoment(input) {
        if (!input || input.length === 0) {
            return null;
        }

        if (input.indexOf("T") > 0) {
            const parts = input.split("T");
            input = parts[0];

            return moment(input, "YYYY-MM-DD").add(-1, 'm');
        }

        return moment(input, "MM/DD/YYYY").add(-1, 'm');
    }
}
